import number from './sorters/number.js';
import string from './sorters/string.js';
import date from './sorters/date.js';
import time from './sorters/time.js';
import datetime from './sorters/datetime.js';
import boolean from './sorters/boolean.js';
import array from './sorters/array.js';
import exists from './sorters/exists.js';
import alphanum from './sorters/alphanum.js';

export default {
	number:number,
	string:string,
	date:date,
	time:time,
	datetime:datetime,
	boolean:boolean,
	array:array,
	exists:exists,
	alphanum:alphanum
};